<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">

            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.goodsOrder.search.goodsName')" prop="goodsName">
                <a-input v-model="queryParam.goodsName" :placeholder="$t('views.goodsOrder.search.goodsNamePlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.goodsOrder.search.orderType')" prop="orderType">
                <a-select v-model="queryParam.orderType" :placeholder="$t('views.goodsOrder.search.orderTypePlaceholder')" allow-clear>
                  <a-select-option v-for="item in orderTypeOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.goodsOrder.search.orderStatus')" prop="orderStatus">
                <a-select v-model="queryParam.orderStatus" :placeholder="$t('views.goodsOrder.search.orderStatusPlaceholder')" allow-clear>
                  <a-select-option v-for="item in orderStatusOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.goodsOrder.search.orderNo')" prop="orderNo">
                <a-input v-model="queryParam.orderNo" :placeholder="$t('views.goodsOrder.search.orderNoPlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.goodsOrder.search.email')" prop="email">
                <a-input v-model="queryParam.email" :placeholder="$t('views.goodsOrder.search.emailPlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.goodsOrder.search.nickname')" prop="nickname">
                <a-input v-model="queryParam.nickname" :placeholder="$t('views.goodsOrder.search.nicknamePlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.goodsOrder.search.createTime')" prop="createTimeRange">
                <a-range-picker
                  v-model="queryParam.createTimeRange"
                  show-time
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  format="YYYY-MM-DD HH:mm:ss"
                  style="width: 100%;"
                  :placeholder="[$t('views.goodsOrder.search.createTimeStart'), $t('views.goodsOrder.search.createTimeEnd')]"
                  allow-clear
                />
              </a-form-item>
            </a-col>
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="用户ID" prop="userId">-->
<!--                <a-input v-model="queryParam.userId" placeholder="请输入用户ID" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="商品ID" prop="goodsId">-->
<!--                <a-input v-model="queryParam.goodsId" placeholder="请输入商品ID" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <template v-if="advanced">

              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsOrder.search.orderNo')" prop="orderNo">
                  <a-input v-model="queryParam.orderNo" :placeholder="$t('views.goodsOrder.search.orderNoPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsOrder.search.width')" prop="width">
                  <a-input v-model="queryParam.width" :placeholder="$t('views.goodsOrder.search.widthPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsOrder.search.height')" prop="height">
                  <a-input v-model="queryParam.height" :placeholder="$t('views.goodsOrder.search.heightPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsOrder.search.bottom')" prop="bottom">
                  <a-input v-model="queryParam.bottom" :placeholder="$t('views.goodsOrder.search.bottomPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsOrder.search.weight')" prop="weight">
                  <a-input v-model="queryParam.weight" :placeholder="$t('views.goodsOrder.search.weightPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsOrder.search.exchangeRate')" prop="exchangeRate">
                  <a-input v-model="queryParam.exchangeRate" :placeholder="$t('views.goodsOrder.search.exchangeRatePlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsOrder.search.shippingMethod')" prop="shippingMethod">
                  <a-input v-model="queryParam.shippingMethod" :placeholder="$t('views.goodsOrder.search.shippingMethodPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsOrder.search.stylesNum')" prop="stylesNum">
                  <a-input v-model="queryParam.stylesNum" :placeholder="$t('views.goodsOrder.search.stylesNumPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsOrder.search.totalNum')" prop="totalNum">
                  <a-input v-model="queryParam.totalNum" :placeholder="$t('views.goodsOrder.search.totalNumPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsOrder.search.payMoney')" prop="payMoney">
                  <a-input v-model="queryParam.payMoney" :placeholder="$t('views.goodsOrder.search.payMoneyPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsOrder.search.firstMoney')" prop="firstMoney">
                  <a-input v-model="queryParam.firstMoney" :placeholder="$t('views.goodsOrder.search.firstMoneyPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsOrder.search.finalMoney')" prop="finalMoney">
                  <a-input v-model="queryParam.finalMoney" :placeholder="$t('views.goodsOrder.search.finalMoneyPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsOrder.search.paidMoney')" prop="paidMoney">
                  <a-input v-model="queryParam.paidMoney" :placeholder="$t('views.goodsOrder.search.paidMoneyPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsOrder.search.shippingMoney')" prop="shippingMoney">
                  <a-input v-model="queryParam.shippingMoney" :placeholder="$t('views.goodsOrder.search.shippingMoneyPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsOrder.search.calculationFormula')" prop="calculationFormula">
                  <a-input v-model="queryParam.calculationFormula" :placeholder="$t('views.goodsOrder.search.calculationFormulaPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsOrder.search.goodMoney')" prop="goodMoney">
                  <a-input v-model="queryParam.goodMoney" :placeholder="$t('views.goodsOrder.search.goodMoneyPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsOrder.search.printingMeters')" prop="printingMeters">
                  <a-input v-model="queryParam.printingMeters" :placeholder="$t('views.goodsOrder.search.printingMetersPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.goodsOrder.search.sort')" prop="sort">
                  <a-input v-model="queryParam.sort" :placeholder="$t('views.goodsOrder.search.sortPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.goodsOrder.action.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.goodsOrder.action.reset') }}</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:goodsOrder:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:goodsOrder:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:goodsOrder:remove']">
          <a-icon type="delete" />{{ $t('views.goodsOrder.action.delete') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <a-drawer
        :title="paymentDrawerTitle"
        placement="right"
        width="85%"
        :visible="paymentDrawerVisible"
        :destroy-on-close="true"
        @close="paymentDrawerVisible = false"
      >
        <order-payment-panel
          v-if="paymentDrawerVisible"
          :key="'pay-' + paymentOrderId"
          :fixed-order-id="paymentOrderId"
          @payment-updated="getList"
        />
      </a-drawer>
      <goods-order-detail-drawer
        :visible="detailDrawerVisible"
        :order-id="detailOrderId"
        :order-no="detailOrderNo"
        @close="detailDrawerVisible = false"
      />
      <a-modal
        :title="$t('views.goodsOrder.modal.editProductionStatusTitle')"
        :visible="productionStatusModalVisible"
        :confirm-loading="productionStatusSubmitting"
        @ok="handleProductionStatusModalOk"
        @cancel="closeProductionStatusModal"
      >
        <a-form-model
          :model="productionStatusForm"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-form-model-item :label="$t('views.goodsOrder.column.productionStatus')" prop="productionStatus">
            <a-select
              v-model="productionStatusForm.productionStatus"
              :placeholder="$t('views.goodsOrder.modal.productionStatusPlaceholder')"
              allow-clear
              style="width: 100%"
            >
              <a-select-option
                v-for="opt in productionStageSelectOptions"
                :key="opt.value"
                :value="opt.value"
              >{{ opt.label }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <a-modal
        :title="$t('views.goodsOrder.modal.editSubmissionEmailTitle')"
        :visible="submissionEmailModalVisible"
        :confirm-loading="submissionEmailSubmitting"
        @ok="handleSubmissionEmailModalOk"
        @cancel="closeSubmissionEmailModal"
      >
        <a-form-model
          :model="submissionEmailForm"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-form-model-item :label="$t('views.goodsOrder.modal.submissionEmailLabel')">
            <a-input
              v-model="submissionEmailForm.submissionEmail"
              type="email"
              autocomplete="email"
              :placeholder="$t('views.goodsOrder.modal.submissionEmailPlaceholder')"
              allow-clear
            />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <a-modal
        :title="$t('views.goodsOrder.modal.markShippedTitle')"
        :visible="markShippedModalVisible"
        :width="720"
        :confirm-loading="markShippedSubmitting"
        @ok="handleMarkShippedModalOk"
        @cancel="closeMarkShippedModal"
      >
        <a-spin :spinning="markShippedAddressLoading">
          <div class="goods-order-box-modal-address">
            <div class="goods-order-box-modal-address-title">{{ $t('views.goodsOrder.detail.shippingAddress') }}</div>
            <template v-if="markShippedOrderAddress">
              <a-descriptions bordered :column="2" size="small">
                <a-descriptions-item :label="$t('views.goodsOrder.detail.receiverName')">{{ orderBoxAddressCell(markShippedOrderAddress.reciverName) }}</a-descriptions-item>
                <a-descriptions-item :label="$t('views.goodsOrder.detail.receiverPhone')">{{ orderBoxAddressCell(markShippedOrderAddress.reciverTelephone) }}</a-descriptions-item>
                <a-descriptions-item :label="$t('views.goodsOrder.detail.addressLabel')">{{ orderBoxAddressCell(markShippedOrderAddress.addressLabel) }}</a-descriptions-item>
                <a-descriptions-item :label="$t('views.goodsOrder.detail.detailedAddress')">{{ orderBoxAddressCell(markShippedOrderAddress.detailedAddress) }}</a-descriptions-item>
              </a-descriptions>
            </template>
            <div v-else-if="!markShippedAddressLoading" class="goods-order-box-modal-address-empty">
              {{ $t('views.goodsOrder.orderBox.noShippingAddress') }}
            </div>
          </div>
        </a-spin>
        <div class="goods-order-box-modal-divider" />
        <a-form-model
          :model="markShippedForm"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-form-model-item :label="$t('views.goodsOrder.orderBox.deliveryNumber')">
            <a-input
              v-model="markShippedForm.deliveryNumber"
              :maxLength="255"
              :placeholder="$t('views.goodsOrder.modal.markShippedDeliveryNumberPlaceholder')"
              allow-clear
            />
          </a-form-model-item>
          <a-form-model-item :label="$t('views.goodsOrder.orderBox.deliveryTime')">
            <a-date-picker
              v-model="markShippedForm.deliveryTime"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              :placeholder="$t('views.goodsOrder.orderBox.deliveryTimePlaceholder')"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <a-modal
        :title="$t('views.goodsOrder.modal.submitOrderBoxesTitle')"
        :visible="orderBoxModalVisible"
        :width="800"
        :confirm-loading="orderBoxSubmitting"
        :ok-text="$t('views.goodsOrder.action.submitOrderBoxes')"
        @ok="handleOrderBoxModalOk"
        @cancel="closeOrderBoxModal"
      >
        <a-spin :spinning="orderBoxAddressLoading">
          <div class="goods-order-box-modal-address">
            <div class="goods-order-box-modal-address-title">{{ $t('views.goodsOrder.detail.shippingAddress') }}</div>
            <template v-if="orderBoxOrderAddress">
              <a-descriptions bordered :column="2" size="small">
                <a-descriptions-item :label="$t('views.goodsOrder.detail.receiverName')">{{ orderBoxAddressCell(orderBoxOrderAddress.reciverName) }}</a-descriptions-item>
                <a-descriptions-item :label="$t('views.goodsOrder.detail.receiverPhone')">{{ orderBoxAddressCell(orderBoxOrderAddress.reciverTelephone) }}</a-descriptions-item>
                <a-descriptions-item :label="$t('views.goodsOrder.detail.addressLabel')">{{ orderBoxAddressCell(orderBoxOrderAddress.addressLabel) }}</a-descriptions-item>
                <a-descriptions-item :label="$t('views.goodsOrder.detail.detailedAddress')">{{ orderBoxAddressCell(orderBoxOrderAddress.detailedAddress) }}</a-descriptions-item>
              </a-descriptions>
            </template>
            <div v-else-if="!orderBoxAddressLoading" class="goods-order-box-modal-address-empty">
              {{ $t('views.goodsOrder.orderBox.noShippingAddress') }}
            </div>
          </div>
        </a-spin>
        <div class="goods-order-box-modal-divider" />
        <div
          v-for="(row, idx) in orderBoxRows"
          :key="row._key"
          class="goods-order-box-modal-row"
        >
          <!-- 第一行：箱规四列 + 删除（与箱规同一行，避免整卡垂直居中） -->
          <a-row :gutter="[12, 12]" type="flex" align="top" class="goods-order-box-modal-row-inner">
            <a-col :xs="24" :md="18" class="goods-order-box-fields-col">
              <a-row :gutter="[12, 10]">
                <a-col :xs="12" :sm="6">
                  <div class="goods-order-box-field-label">{{ $t('views.goodsOrder.orderBox.boxLength') }}</div>
                  <a-input-number
                    v-model="row.boxLength"
                    :min="0.01"
                    :step="0.01"
                    :precision="2"
                    class="goods-order-box-input"
                  />
                </a-col>
                <a-col :xs="12" :sm="6">
                  <div class="goods-order-box-field-label">{{ $t('views.goodsOrder.orderBox.boxWidth') }}</div>
                  <a-input-number
                    v-model="row.boxWidth"
                    :min="0.01"
                    :step="0.01"
                    :precision="2"
                    class="goods-order-box-input"
                  />
                </a-col>
                <a-col :xs="12" :sm="6">
                  <div class="goods-order-box-field-label">{{ $t('views.goodsOrder.orderBox.boxHeight') }}</div>
                  <a-input-number
                    v-model="row.boxHeight"
                    :min="0.01"
                    :step="0.01"
                    :precision="2"
                    class="goods-order-box-input"
                  />
                </a-col>
                <a-col :xs="12" :sm="6">
                  <div class="goods-order-box-field-label">{{ $t('views.goodsOrder.orderBox.boxNum') }}</div>
                  <a-input-number
                    v-model="row.boxNum"
                    :min="1"
                    :precision="0"
                    class="goods-order-box-input"
                  />
                </a-col>
              </a-row>
            </a-col>
            <a-col :xs="24" :md="6" class="goods-order-box-remove-col">
              <a-button type="link" size="small" class="goods-order-box-remove-btn" @click="removeOrderBoxRow(idx)">
                {{ $t('views.goodsOrder.orderBox.removeRow') }}
              </a-button>
            </a-col>
            <!-- 发货单号、发货时间（暂隐藏）
            <a-col :span="24" class="goods-order-box-modal-row-delivery">
              <a-row :gutter="[12, 10]">
                <a-col :xs="24" :md="14">
                  <div class="goods-order-box-field-label">{{ $t('views.goodsOrder.orderBox.deliveryNumber') }}</div>
                  <a-input
                    v-model="row.deliveryNumber"
                    :maxLength="255"
                    :placeholder="$t('views.goodsOrder.orderBox.deliveryNumberPlaceholder')"
                    allow-clear
                  />
                </a-col>
                <a-col :xs="24" :md="10">
                  <div class="goods-order-box-field-label">{{ $t('views.goodsOrder.orderBox.deliveryTime') }}</div>
                  <a-date-picker
                    v-model="row.deliveryTime"
                    show-time
                    format="YYYY-MM-DD HH:mm:ss"
                    :placeholder="$t('views.goodsOrder.orderBox.deliveryTimePlaceholder')"
                    style="width: 100%"
                  />
                </a-col>
              </a-row>
            </a-col>
            -->
          </a-row>
        </div>
        <a-button type="dashed" block style="margin-top: 8px" @click="addOrderBoxRow">
          <a-icon type="plus" />{{ $t('views.goodsOrder.orderBox.addRow') }}
        </a-button>
      </a-modal>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <span slot="orderType" slot-scope="text, record">
          {{ formatOrderType(record.orderType) }}
        </span>
        <span slot="orderStatus" slot-scope="text, record">
          {{ formatOrderStatus(record.orderStatus) }}
        </span>
        <span slot="firstStatus" slot-scope="text, record">
          <a-switch
            :checked="record.firstStatus == 1 || record.firstStatus == '1'"
            @change="(checked) => handleStatusChange(record, checked)"
          />
        </span>
        <span slot="finalStatus" slot-scope="text, record">
          <a-switch
            :checked="record.finalStatus == 1 || record.finalStatus == '1'"
            @change="(checked) => handleStatusChange(record, checked)"
          />
        </span>
        <span slot="productionStatus" slot-scope="text, record">
          {{ formatProductionStage(record.productionStatus) }}
        </span>
        <span slot="sort" slot-scope="text, record">
          <a-input-number
            :value="record.sort"
            :min="0"
            style="width: 100px"
            @change="(value) => handleSortChange(record, value, 'sort')"
          />
        </span>
        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status == 1 || record.status == '1'"
            @change="(checked) => handleStatusChange(record, checked)"
          />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <!-- 详情：侧滑查看订单完整信息（user:goodsOrder:query） -->
          <a v-hasPermi="['user:goodsOrder:query']" @click="openDetailDrawer(record)">
            <a-icon type="file-text" />{{ $t('views.goodsOrder.action.detail') }}
          </a>
          <a-divider v-hasPermi="['user:orderPayment:list']" v-if="record.orderType != 2" type="vertical" />
          <!-- 支付记录：侧滑订单付款列表（user:orderPayment:list） -->
          <a v-hasPermi="['user:orderPayment:list']" @click="openPaymentDrawer(record)" v-if="record.orderType != 2">
            <a-icon type="account-book" />{{ $t('views.goodsOrder.action.paymentRecord') }}
          </a>
          <!-- 待发稿(4)：修改收稿邮箱 / 标记已收稿 -->
          <template v-if="isOrderAwaitDraft(record)">
            <a-divider type="vertical" v-hasPermi="['user:goodsOrder:edit']" />
            <a @click="openSubmissionEmailModal(record)" v-hasPermi="['user:goodsOrder:edit']">
              <a-icon type="mail" />{{ $t('views.goodsOrder.action.editSubmissionEmail') }}
            </a>
            <a-divider type="vertical" v-hasPermi="['user:goodsOrder:edit']" />
            <a @click="handleMarkDraftReceived(record)" v-hasPermi="['user:goodsOrder:edit']">
              <a-icon type="check-circle" />{{ $t('views.goodsOrder.action.markDraftReceived') }}
            </a>
          </template>
          <!-- 设为生产中：仅「已收稿」(5) 显示；二次确认后将订单置为生产中(6) -->
          <template v-if="isOrderDraftReceived(record)">
            <a-divider type="vertical" v-hasPermi="['user:goodsOrder:edit']" />
            <a @click="handleMarkProducing(record)" v-hasPermi="['user:goodsOrder:edit']">
              <a-icon type="tool" />{{ $t('views.goodsOrder.action.markProducing') }}
            </a>
          </template>
          <!-- 生产中(6)：修改生产环节(1-8) / 录入箱规并转待发货(7) -->
          <template v-if="isOrderProducing(record)">
            <a-divider type="vertical" v-hasPermi="['user:goodsOrder:edit']" />
            <a @click="openProductionStatusModal(record)" v-hasPermi="['user:goodsOrder:edit']">
              <a-icon type="edit" />{{ $t('views.goodsOrder.action.editProductionStatus') }}
            </a>
            <a-divider type="vertical" v-hasPermi="['user:goodsOrder:edit']" />
            <a @click="openOrderBoxModal(record)" v-hasPermi="['user:goodsOrder:edit']">
              <a-icon type="inbox" />{{ $t('views.goodsOrder.action.submitOrderBoxes') }}
            </a>
          </template>
          <!-- 待发货(7)：非首款 → 已发货(9)；首款(1) → 待收尾款(8) -->
          <template v-if="isOrderAwaitShipNonFirst(record)">
            <a-divider type="vertical" v-hasPermi="['user:goodsOrder:edit']" />
            <a @click="handleMarkShippedFromAwaitShip(record)" v-hasPermi="['user:goodsOrder:edit']">
              <a-icon type="export" />{{ $t('views.goodsOrder.action.markShippedFromAwaitShip') }}
            </a>
          </template>
          <template v-if="isOrderAwaitShipFirst(record)">
            <a-divider type="vertical" v-hasPermi="['user:goodsOrder:edit']" />
            <a @click="handleMarkAwaitFinalPaymentFromAwaitShip(record)" v-hasPermi="['user:goodsOrder:edit']">
              <a-icon type="pay-circle" />{{ $t('views.goodsOrder.action.markAwaitFinalPaymentFromAwaitShip') }}
            </a>
          </template>
          <!-- 已发货(9)：标记已完成(10) -->
          <template v-if="isOrderShipped(record)">
            <a-divider type="vertical" v-hasPermi="['user:goodsOrder:edit']" />
            <a @click="handleMarkCompletedFromShipped(record)" v-hasPermi="['user:goodsOrder:edit']">
              <a-icon type="check-square" />{{ $t('views.goodsOrder.action.markCompletedFromShipped') }}
            </a>
          </template>
          <!-- 删除：二次确认后删除订单（需删除权限） -->
          <a-divider type="vertical" v-hasPermi="['user:goodsOrder:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['user:goodsOrder:remove']">
            <a-icon type="delete" />{{ $t('views.goodsOrder.action.delete') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :show-total="paginationShowTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import moment from 'moment'
import { pageGoodsOrder, delGoodsOrder, updateGoodsOrder, getGoodsOrder, markGoodsOrderDraftReceived, markGoodsOrderProducing, updateGoodsOrderProductionStatus, submitGoodsOrderBoxesAwaitShip, updateGoodsOrderSubmissionEmail, markGoodsOrderShippedFromAwaitShip, markGoodsOrderAwaitFinalPaymentFromAwaitShip, markGoodsOrderCompletedFromShipped } from '@/api/user/goodsOrder'
import CreateForm from './modules/CreateForm'
import GoodsOrderDetailDrawer from './modules/GoodsOrderDetailDrawer'
import OrderPaymentPanel from '@/views/user/orderPayment/modules/OrderPaymentPanel'
import { tableMixin } from '@/store/table-mixin'
import auth from '@/plugins/auth'

export default {
  name: 'GoodsOrder',
  components: {
    CreateForm,
    GoodsOrderDetailDrawer,
    OrderPaymentPanel
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      paymentDrawerVisible: false,
      paymentOrderId: null,
      paymentOrderNo: '',
      detailDrawerVisible: false,
      detailOrderId: null,
      detailOrderNo: '',
      productionStatusModalVisible: false,
      productionStatusSubmitting: false,
      productionStatusForm: {
        id: null,
        productionStatus: undefined
      },
      submissionEmailModalVisible: false,
      submissionEmailSubmitting: false,
      submissionEmailForm: {
        id: null,
        submissionEmail: ''
      },
      markShippedModalVisible: false,
      markShippedSubmitting: false,
      markShippedAddressLoading: false,
      markShippedOrderAddress: null,
      markShippedForm: {
        id: null,
        deliveryNumber: '',
        deliveryTime: null
      },
      orderBoxModalVisible: false,
      orderBoxSubmitting: false,
      orderBoxOrderId: null,
      orderBoxAddressLoading: false,
      orderBoxOrderAddress: null,
      orderBoxRowSeq: 0,
      orderBoxRows: [],
      // 查询参数
      queryParam: {
        userId: null,
        goodsId: null,
        goodsName: null,
        orderType: null,
        orderStatus: null,
        firstStatus: null,
        finalStatus: null,
        productionStatus: null,
        orderNo: null,
        width: null,
        height: null,
        bottom: null,
        weight: null,
        exchangeRate: null,
        shippingMethod: null,
        stylesNum: null,
        totalNum: null,
        payMoney: null,
        firstMoney: null,
        finalMoney: null,
        paidMoney: null,
        shippingMoney: null,
        calculationFormula: null,
        goodMoney: null,
        printingMeters: null,
        typesettingType: null,
        sort: null,
        status: null,
        email: null,
        nickname: null,
        createTimeRange: [],
        createBeginTime: null,
        createEndTime: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: []
    }
  },
  filters: {
  },
  created () {
    this.buildColumns()
    this.getList()
  },
  computed: {
    paymentDrawerTitle () {
      return this.$t('views.goodsOrder.drawer.paymentTitleWithOrder', { orderNo: this.paymentOrderNo || '-' })
    },
    orderTypeOptions () {
      return [
        { value: 0, label: this.$t('views.goodsOrder.orderType.full') },
        { value: 1, label: this.$t('views.goodsOrder.orderType.first') },
        { value: 2, label: this.$t('views.goodsOrder.orderType.monthly') }
      ]
    },
    productionStageSelectOptions () {
      return [1, 2, 3, 4, 5, 6, 7, 8].map(v => ({
        value: v,
        label: this.$t('views.goodsOrder.productionStage.' + v)
      }))
    },
    /** 与「详情」按钮一致，用于分隔线避免权限不全时出现多余竖线 */
    canGoodsOrderQuery () {
      return auth.hasPermi('user:goodsOrder:query')
    },
    /** 与「支付记录」按钮一致 */
    canOrderPaymentList () {
      return auth.hasPermi('user:orderPayment:list')
    },
    showDividerBetweenDetailAndPayment () {
      return this.canGoodsOrderQuery && this.canOrderPaymentList
    },
    orderStatusOptions () {
      return [
        { value: 0, label: this.$t('views.goodsOrder.orderStatus.pending') },
        { value: 1, label: this.$t('views.goodsOrder.orderStatus.awaitPay') },
        { value: 2, label: this.$t('views.goodsOrder.orderStatus.paidAwaitAudit') },
        { value: 3, label: this.$t('views.goodsOrder.orderStatus.factoryRejected') },
        { value: 4, label: this.$t('views.goodsOrder.orderStatus.awaitDraft') },
        { value: 5, label: this.$t('views.goodsOrder.orderStatus.draftReceived') },
        { value: 6, label: this.$t('views.goodsOrder.orderStatus.producing') },
        { value: 7, label: this.$t('views.goodsOrder.orderStatus.awaitShip') },
        { value: 8, label: this.$t('views.goodsOrder.orderStatus.awaitFinalPayment') },
        { value: 9, label: this.$t('views.goodsOrder.orderStatus.shipped') },
        { value: 10, label: this.$t('views.goodsOrder.orderStatus.completed') },
        { value: -1, label: this.$t('views.goodsOrder.orderStatus.cancelled') }
      ]
    }
  },
  watch: {
    '$i18n.locale' () {
      this.buildColumns()
    }
  },
  methods: {
    /** 订单状态 4：待发稿（列表里与「已收稿」操作对应） */
    isOrderAwaitDraft (record) {
      const s = record && record.orderStatus
      return s !== null && s !== undefined && Number(s) === 4
    },
    /** 订单状态 5：已收稿（可「设为生产中」） */
    isOrderDraftReceived (record) {
      const s = record && record.orderStatus
      return s !== null && s !== undefined && Number(s) === 5
    },
    /** 订单状态 6：生产中（可修改 production_status） */
    isOrderProducing (record) {
      const s = record && record.orderStatus
      return s !== null && s !== undefined && Number(s) === 6
    },
    /** 订单状态 7 待发货且订单类型非首款(≠1)：可标记已发货(9) */
    isOrderAwaitShipNonFirst (record) {
      const s = record && record.orderStatus
      const t = record && record.orderType
      if (s === null || s === undefined || Number(s) !== 7) {
        return false
      }
      return Number(t) !== 1
    },
    /** 订单状态 7 待发货且首款订单(1)：可标记待收尾款(8) */
    isOrderAwaitShipFirst (record) {
      const s = record && record.orderStatus
      const t = record && record.orderType
      if (s === null || s === undefined || Number(s) !== 7) {
        return false
      }
      return Number(t) === 1
    },
    /** 订单状态 9：已发货，可标记已完成(10) */
    isOrderShipped (record) {
      const s = record && record.orderStatus
      return s !== null && s !== undefined && Number(s) === 9
    },
    formatProductionStage (value) {
      if (value === null || value === undefined || value === '') {
        return '—'
      }
      const n = Number(value)
      if (Number.isNaN(n) || n < 1 || n > 8) {
        return String(value)
      }
      return this.$t('views.goodsOrder.productionStage.' + n)
    },
    openProductionStatusModal (record) {
      this.productionStatusForm.id = record.id
      const ps = record.productionStatus
      const n = ps != null && ps !== '' ? Number(ps) : NaN
      this.productionStatusForm.productionStatus =
        !Number.isNaN(n) && n >= 1 && n <= 8 ? n : undefined
      this.productionStatusModalVisible = true
    },
    closeProductionStatusModal () {
      this.productionStatusModalVisible = false
      this.productionStatusSubmitting = false
      this.productionStatusForm = { id: null, productionStatus: undefined }
    },
    isValidEmailFormat (s) {
      if (s == null || String(s).trim() === '') {
        return true
      }
      const t = String(s).trim()
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(t)
    },
    openSubmissionEmailModal (record) {
      this.submissionEmailForm.id = record.id
      const v = record.submissionEmail
      this.submissionEmailForm.submissionEmail = v != null && v !== undefined ? String(v) : ''
      this.submissionEmailModalVisible = true
    },
    closeSubmissionEmailModal () {
      this.submissionEmailModalVisible = false
      this.submissionEmailSubmitting = false
      this.submissionEmailForm = { id: null, submissionEmail: '' }
    },
    handleSubmissionEmailModalOk () {
      const raw = this.submissionEmailForm.submissionEmail
      const trimmed = raw != null ? String(raw).trim() : ''
      if (trimmed !== '' && !this.isValidEmailFormat(trimmed)) {
        this.$message.warning(this.$t('views.goodsOrder.msg.submissionEmailInvalid'))
        return Promise.reject(new Error('validation'))
      }
      this.submissionEmailSubmitting = true
      const payload = {
        id: this.submissionEmailForm.id,
        submissionEmail: trimmed === '' ? '' : trimmed
      }
      return updateGoodsOrderSubmissionEmail(payload)
        .then(() => {
          this.$message.success(this.$t('views.goodsOrder.msg.submissionEmailOk'), 3)
          this.closeSubmissionEmailModal()
          this.getList()
        })
        .finally(() => {
          this.submissionEmailSubmitting = false
        })
    },
    handleProductionStatusModalOk () {
      if (this.productionStatusForm.productionStatus === null ||
        this.productionStatusForm.productionStatus === undefined) {
        this.$message.warning(this.$t('views.goodsOrder.modal.productionStatusPlaceholder'))
        return Promise.reject(new Error('validation'))
      }
      this.productionStatusSubmitting = true
      const payload = {
        id: this.productionStatusForm.id,
        productionStatus: this.productionStatusForm.productionStatus
      }
      return updateGoodsOrderProductionStatus(payload)
        .then(() => {
          this.$message.success(this.$t('views.goodsOrder.msg.updateProductionStatusOk'), 3)
          this.closeProductionStatusModal()
          this.getList()
        })
        .finally(() => {
          this.productionStatusSubmitting = false
        })
    },
    createEmptyOrderBoxRow () {
      this.orderBoxRowSeq += 1
      return {
        _key: 'ob-' + this.orderBoxRowSeq,
        boxLength: undefined,
        boxWidth: undefined,
        boxHeight: undefined,
        boxNum: undefined
        // deliveryNumber: '',
        // deliveryTime: moment()
      }
    },
    openOrderBoxModal (record) {
      this.orderBoxOrderId = record.id
      this.orderBoxRowSeq = 0
      this.orderBoxRows = [this.createEmptyOrderBoxRow()]
      this.orderBoxOrderAddress = null
      this.orderBoxAddressLoading = true
      this.orderBoxModalVisible = true
      getGoodsOrder({ id: record.id })
        .then(res => {
          const d = res && res.data
          this.orderBoxOrderAddress = d && d.orderAddress ? d.orderAddress : null
        })
        .catch(() => {
          this.$message.error(this.$t('views.goodsOrder.msg.loadDetailFail'))
          this.orderBoxOrderAddress = null
        })
        .finally(() => {
          this.orderBoxAddressLoading = false
        })
    },
    closeOrderBoxModal () {
      this.orderBoxModalVisible = false
      this.orderBoxSubmitting = false
      this.orderBoxOrderId = null
      this.orderBoxAddressLoading = false
      this.orderBoxOrderAddress = null
      this.orderBoxRows = []
      this.orderBoxRowSeq = 0
    },
    /** 箱规弹窗内收货地址展示（与详情抽屉一致） */
    orderBoxAddressCell (v) {
      if (v === null || v === undefined || v === '') {
        return '—'
      }
      return v
    },
    addOrderBoxRow () {
      this.orderBoxRows.push(this.createEmptyOrderBoxRow())
    },
    removeOrderBoxRow (idx) {
      if (this.orderBoxRows.length <= 1) {
        this.$message.warning(this.$t('views.goodsOrder.orderBox.keepOneRow'))
        return
      }
      this.orderBoxRows.splice(idx, 1)
    },
    isPositiveNumber (v) {
      const n = Number(v)
      return v !== null && v !== undefined && v !== '' && !Number.isNaN(n) && n > 0
    },
    validateOrderBoxDimensions () {
      for (let i = 0; i < this.orderBoxRows.length; i++) {
        const r = this.orderBoxRows[i]
        if (!this.isPositiveNumber(r.boxLength) ||
          !this.isPositiveNumber(r.boxWidth) ||
          !this.isPositiveNumber(r.boxHeight)) {
          return false
        }
        const n = Number(r.boxNum)
        if (r.boxNum === null || r.boxNum === undefined || r.boxNum === '' ||
          Number.isNaN(n) || !Number.isInteger(n) || n < 1) {
          return false
        }
      }
      return true
    },
    // validateOrderBoxDeliveryTimes () {
    //   return this.orderBoxRows.every(r => !!this.formatOrderBoxRowDeliveryTimeForSubmit(r.deliveryTime))
    // },
    // /** 单行发货时间 → yyyy-MM-dd HH:mm:ss */
    // formatOrderBoxRowDeliveryTimeForSubmit (dt) {
    //   if (dt == null) {
    //     return ''
    //   }
    //   if (typeof dt.format === 'function') {
    //     return dt.format('YYYY-MM-DD HH:mm:ss')
    //   }
    //   const m = moment(dt)
    //   return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : ''
    // },
    handleOrderBoxModalOk () {
      if (!this.validateOrderBoxDimensions()) {
        this.$message.warning(this.$t('views.goodsOrder.orderBox.validateRows'))
        return Promise.reject(new Error('validation'))
      }
      // if (!this.validateOrderBoxDeliveryTimes()) {
      //   this.$message.warning(this.$t('views.goodsOrder.orderBox.deliveryTimeRequired'))
      //   return Promise.reject(new Error('validation'))
      // }
      this.orderBoxSubmitting = true
      const boxes = this.orderBoxRows.map((r, idx) => {
        // const dn = r.deliveryNumber != null ? String(r.deliveryNumber).trim() : ''
        return {
          boxLength: Number(r.boxLength),
          boxWidth: Number(r.boxWidth),
          boxHeight: Number(r.boxHeight),
          boxNum: Number(r.boxNum),
          sort: idx
          // deliveryNumber: dn || undefined,
          // deliveryTime: this.formatOrderBoxRowDeliveryTimeForSubmit(r.deliveryTime)
        }
      })
      return submitGoodsOrderBoxesAwaitShip({
        orderId: this.orderBoxOrderId,
        boxes
      })
        .then(() => {
          this.$message.success(this.$t('views.goodsOrder.msg.submitOrderBoxesOk'), 3)
          this.closeOrderBoxModal()
          this.getList()
        })
        .finally(() => {
          this.orderBoxSubmitting = false
        })
    },
    buildColumns () {
      const t = k => this.$t(k)
      this.columns = [
        { title: t('views.goodsOrder.column.id'), dataIndex: 'id', ellipsis: true, align: 'center' },
        { title: t('views.goodsOrder.column.email'), dataIndex: 'email', ellipsis: true, align: 'center' },
        { title: t('views.goodsOrder.column.nickname'), dataIndex: 'nickname', ellipsis: true, align: 'center' },
        {
          title: t('views.goodsOrder.column.orderType'),
          dataIndex: 'orderType',
          scopedSlots: { customRender: 'orderType' },
          ellipsis: true,
          align: 'center'
        },
        { title: t('views.goodsOrder.column.goodsName'), dataIndex: 'goodsName', ellipsis: true, align: 'center' },
        {
          title: t('views.goodsOrder.column.orderStatus'),
          dataIndex: 'orderStatus',
          scopedSlots: { customRender: 'orderStatus' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.goodsOrder.column.productionStatus'),
          dataIndex: 'productionStatus',
          scopedSlots: { customRender: 'productionStatus' },
          ellipsis: true,
          align: 'center',
          width: 120
        },
        { title: t('views.goodsOrder.column.orderNo'), dataIndex: 'orderNo', ellipsis: true, align: 'center' },
        { title: t('views.goodsOrder.column.height'), dataIndex: 'height', ellipsis: true, align: 'center' },
        { title: t('views.goodsOrder.column.width'), dataIndex: 'width', ellipsis: true, align: 'center' },
        { title: t('views.goodsOrder.column.bottom'), dataIndex: 'bottom', ellipsis: true, align: 'center' },
        { title: t('views.goodsOrder.column.thickness'), dataIndex: 'thickness', ellipsis: true, align: 'center' },
        { title: t('views.goodsOrder.column.stylesNum'), dataIndex: 'stylesNum', ellipsis: true, align: 'center' },
        { title: t('views.goodsOrder.column.totalNum'), dataIndex: 'totalNum', ellipsis: true, align: 'center' },
        { title: t('views.goodsOrder.column.payMoney'), dataIndex: 'payMoney', ellipsis: true, align: 'center' },
        {
          title: t('views.goodsOrder.column.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.goodsOrder.column.operation'),
          dataIndex: 'operation',
          width: 780,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    },
    paginationShowTotal (total) {
      return this.$t('views.goodsOrder.pagination.total', { total })
    },
    openDetailDrawer (record) {
      this.detailOrderId = record.id
      this.detailOrderNo = record.orderNo != null && record.orderNo !== '' ? String(record.orderNo) : String(record.id)
      this.detailDrawerVisible = true
    },
    openPaymentDrawer (record) {
      this.paymentOrderId = record.id
      this.paymentOrderNo = record.orderNo != null && record.orderNo !== '' ? String(record.orderNo) : String(record.id)
      this.paymentDrawerVisible = true
    },
    formatOrderType (value) {
      if (value === null || value === undefined || value === '') {
        return ''
      }
      const numVal = Number(value)
      const hit = (this.orderTypeOptions || []).find(o => Number(o.value) === numVal)
      return hit ? hit.label : String(value)
    },
    formatOrderStatus (value) {
      if (value === null || value === undefined || value === '') {
        return ''
      }
      const numVal = Number(value)
      const hit = (this.orderStatusOptions || []).find(o => Number(o.value) === numVal)
      return hit ? hit.label : String(value)
    },
    /** 查询订单列表 */
    getList () {
      this.loading = true
      // 创建时间区间（年月日时分秒）
      if (Array.isArray(this.queryParam.createTimeRange) && this.queryParam.createTimeRange.length === 2) {
        const [begin, end] = this.queryParam.createTimeRange
        this.queryParam.createBeginTime = begin || undefined
        this.queryParam.createEndTime = end || undefined
      } else {
        this.queryParam.createBeginTime = undefined
        this.queryParam.createEndTime = undefined
      }
     pageGoodsOrder(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        goodsId: undefined,
        goodsName: undefined,
        orderType: undefined,
        orderStatus: undefined,
        firstStatus: undefined,
        finalStatus: undefined,
        productionStatus: undefined,
        orderNo: undefined,
        width: undefined,
        height: undefined,
        bottom: undefined,
        weight: undefined,
        exchangeRate: undefined,
        shippingMethod: undefined,
        stylesNum: undefined,
        totalNum: undefined,
        payMoney: undefined,
        firstMoney: undefined,
        finalMoney: undefined,
        paidMoney: undefined,
        shippingMoney: undefined,
        calculationFormula: undefined,
        goodMoney: undefined,
        printingMeters: undefined,
        typesettingType: undefined,
        sort: undefined,
        status: undefined,
        email: undefined,
        nickname: undefined,
        createTimeRange: [],
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 待发稿 → 已收稿（二次确认） */
    handleMarkDraftReceived (record) {
      const that = this
      const orderNo = record.orderNo != null && record.orderNo !== '' ? String(record.orderNo) : String(record.id)
      this.$confirm({
        title: this.$t('views.goodsOrder.confirm.markDraftReceivedTitle'),
        content: this.$t('views.goodsOrder.confirm.markDraftReceivedContent', { orderNo }),
        onOk () {
          return markGoodsOrderDraftReceived({ id: record.id })
            .then(() => {
              that.$message.success(that.$t('views.goodsOrder.msg.markDraftReceivedOk'), 3)
              that.getList()
            })
        }
      })
    },
    /** 已收稿 → 生产中（二次确认） */
    handleMarkProducing (record) {
      const that = this
      const orderNo = record.orderNo != null && record.orderNo !== '' ? String(record.orderNo) : String(record.id)
      this.$confirm({
        title: this.$t('views.goodsOrder.confirm.markProducingTitle'),
        content: this.$t('views.goodsOrder.confirm.markProducingContent', { orderNo }),
        onOk () {
          return markGoodsOrderProducing({ id: record.id })
            .then(() => {
              that.$message.success(that.$t('views.goodsOrder.msg.markProducingOk'), 3)
              that.getList()
            })
        }
      })
    },
    /** 待发货(7) 非首款 → 已发货(9)，弹窗录入发货单号与时间 */
    handleMarkShippedFromAwaitShip (record) {
      this.openMarkShippedModal(record)
    },
    openMarkShippedModal (record) {
      this.markShippedForm = {
        id: record.id,
        deliveryNumber: '',
        deliveryTime: moment()
      }
      this.markShippedOrderAddress = null
      this.markShippedAddressLoading = true
      this.markShippedModalVisible = true
      getGoodsOrder({ id: record.id })
        .then(res => {
          const d = res && res.data
          this.markShippedOrderAddress = d && d.orderAddress ? d.orderAddress : null
        })
        .catch(() => {
          this.$message.error(this.$t('views.goodsOrder.msg.loadDetailFail'))
          this.markShippedOrderAddress = null
        })
        .finally(() => {
          this.markShippedAddressLoading = false
        })
    },
    closeMarkShippedModal () {
      this.markShippedModalVisible = false
      this.markShippedSubmitting = false
      this.markShippedAddressLoading = false
      this.markShippedOrderAddress = null
      this.markShippedForm = {
        id: null,
        deliveryNumber: '',
        deliveryTime: null
      }
    },
    formatMarkShippedDeliveryTimeForSubmit () {
      const dt = this.markShippedForm.deliveryTime
      if (dt == null) {
        return ''
      }
      if (typeof dt.format === 'function') {
        return dt.format('YYYY-MM-DD HH:mm:ss')
      }
      const m = moment(dt)
      return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : ''
    },
    handleMarkShippedModalOk () {
      const dn = this.markShippedForm.deliveryNumber != null ? String(this.markShippedForm.deliveryNumber).trim() : ''
      if (!dn) {
        this.$message.warning(this.$t('views.goodsOrder.msg.markShippedDeliveryNumberRequired'))
        return Promise.reject(new Error('validation'))
      }
      const deliveryTimeStr = this.formatMarkShippedDeliveryTimeForSubmit()
      if (!deliveryTimeStr) {
        this.$message.warning(this.$t('views.goodsOrder.msg.markShippedDeliveryTimeRequired'))
        return Promise.reject(new Error('validation'))
      }
      const that = this
      this.markShippedSubmitting = true
      return markGoodsOrderShippedFromAwaitShip({
        id: this.markShippedForm.id,
        deliveryNumber: dn,
        deliveryTime: deliveryTimeStr
      })
        .then(() => {
          that.$message.success(that.$t('views.goodsOrder.msg.markShippedFromAwaitShipOk'), 3)
          that.closeMarkShippedModal()
          that.getList()
        })
        .finally(() => {
          that.markShippedSubmitting = false
        })
    },
    /** 待发货(7) 首款 → 待收尾款(8) */
    handleMarkAwaitFinalPaymentFromAwaitShip (record) {
      const that = this
      const orderNo = record.orderNo != null && record.orderNo !== '' ? String(record.orderNo) : String(record.id)
      this.$confirm({
        title: this.$t('views.goodsOrder.confirm.markAwaitFinalPaymentFromAwaitShipTitle'),
        content: this.$t('views.goodsOrder.confirm.markAwaitFinalPaymentFromAwaitShipContent', { orderNo }),
        onOk () {
          return markGoodsOrderAwaitFinalPaymentFromAwaitShip({ id: record.id })
            .then(() => {
              that.$message.success(that.$t('views.goodsOrder.msg.markAwaitFinalPaymentFromAwaitShipOk'), 3)
              that.getList()
            })
        }
      })
    },
    /** 已发货(9) → 已完成(10) */
    handleMarkCompletedFromShipped (record) {
      const that = this
      const orderNo = record.orderNo != null && record.orderNo !== '' ? String(record.orderNo) : String(record.id)
      this.$confirm({
        title: this.$t('views.goodsOrder.confirm.markCompletedFromShippedTitle'),
        content: this.$t('views.goodsOrder.confirm.markCompletedFromShippedContent', { orderNo }),
        onOk () {
          return markGoodsOrderCompletedFromShipped({ id: record.id })
            .then(() => {
              that.$message.success(that.$t('views.goodsOrder.msg.markCompletedFromShippedOk'), 3)
              that.getList()
            })
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      const idText = Array.isArray(ids) ? ids.join(', ') : String(ids)
      this.$confirm({
        title: this.$t('views.goodsOrder.confirm.deleteTitle'),
        content: this.$t('views.goodsOrder.confirm.deleteContent', { ids: idText }),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delGoodsOrder(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('views.goodsOrder.msg.deleteOk'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('views.goodsOrder.confirm.exportTitle'),
        content: this.$t('views.goodsOrder.confirm.exportContent'),
        onOk () {
          const time = new Date().getTime()
          that.download('user/goods-order/export', {
            ...that.queryParam
          }, that.$t('views.goodsOrder.export.filename', { time }))
        },
        onCancel () {}
      })
    },
    /** 状态开关变更 */
    handleStatusChange (record, checked) {
      const statusValue = checked ? 1 : 0
      const updateData = {
        id: record.id,
        status: statusValue
      }
      updateGoodsOrder(updateData).then(() => {
        record.status = statusValue
        this.$message.success(this.$t('views.goodsOrder.msg.statusOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.goodsOrder.msg.statusFail'))
      })
    },
    /** 排序值变更 */
    handleSortChange (record, value, fieldName) {
      if (value === null || value === undefined) {
        return
      }
      const updateData = {
        id: record.id
      }
      updateData[fieldName] = value
      updateGoodsOrder(updateData).then(() => {
        record[fieldName] = value
        this.$message.success(this.$t('views.goodsOrder.msg.sortOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.goodsOrder.msg.sortFail'))
      })
    }
  }
}
</script>

<style scoped>
.goods-order-box-modal-address {
  margin-bottom: 8px;
}
.goods-order-box-modal-address-title {
  font-weight: 600;
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.85);
}
.goods-order-box-modal-address-empty {
  color: rgba(0, 0, 0, 0.45);
  font-size: 13px;
  padding: 8px 0;
}
.goods-order-box-modal-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 12px 0 16px;
}
/* .goods-order-box-modal-row-delivery { margin-top: 2px; } */
.goods-order-box-modal-row {
  margin-bottom: 12px;
  padding: 14px 16px 16px;
  background: #fafafa;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
}
.goods-order-box-modal-row:last-of-type {
  margin-bottom: 0;
}
.goods-order-box-modal-row-inner {
  flex-wrap: wrap;
}
.goods-order-box-fields-col {
  padding-left: 2px;
}
.goods-order-box-field-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 6px;
  white-space: nowrap;
}
.goods-order-box-input {
  width: 100%;
}
/* 删除与箱规首行对齐：顶对齐 + 与标签+输入区视觉对齐 */
.goods-order-box-remove-col {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 24px 0 0 8px;
  margin-top: 0;
  border-left: 1px solid #f0f0f0;
}
.goods-order-box-remove-btn {
  padding-left: 4px;
  padding-right: 4px;
  line-height: 1.2;
}
@media (max-width: 767px) {
  .goods-order-box-remove-col {
    border-left: none;
    border-top: none;
    margin-top: 0;
    padding: 4px 0 0;
    justify-content: flex-end;
  }
}
</style>
